import { Uploader } from '../../components/uploader';

if (document.body.id === 'uploader-demo') {
    main();
}

function main() {
    const $skinny = document.querySelector('#uploader-skinny') as HTMLInputElement;
    const $skinnyLabel = $skinny.closest('.uploader-dropzone') as HTMLLabelElement;
    const u = new Uploader($skinnyLabel);
    // eslint-disable-next-line no-console
    setInterval(() => console.log(u.GetUploadIDs()), 1000);

    const $wide = document.querySelector('#uploader-wide') as HTMLInputElement;
    const $wideLabel = $wide.closest('.uploader-dropzone') as HTMLLabelElement;
    new Uploader($wideLabel);
}